<script setup lang="ts">
import type { TextWithImageData } from 'types/blocks';
import type { ComponentStyles } from 'types/index';

defineProps<{
  data: TextWithImageData;
  componentStyles: ComponentStyles;
}>();
</script>

<template>
  <BaseComponentWrapper
    v-if="data"
    :component-styles="componentStyles"
  >
    <article class="container grid grid-cols-12 gap-y-8 lg:gap-24">
      <div
        class="col-span-12 flex w-full items-center lg:col-span-6"
        :class="{ 'order-last': data.reverse }"
      >
        <div>
          <BaseRte
            v-if="data.text"
            :content="data.text"
          />

          <BaseButton
            v-if="data.cta"
            class="mt-6 md:mt-12"
            :to="data.cta.url"
            :title="data.cta.name"
          >
            {{ data.cta.name }}
          </BaseButton>
        </div>
      </div>

      <div class="col-span-12 flex w-full items-center overflow-hidden lg:col-span-6">
        <BaseScrollTransition
          class="size-full"
          content-class="size-full"
        >
          <figure
            v-if="data.image?.url"
            class="size-full"
          >
            <BaseImage
              :image="data.image"
              class="size-full object-cover md:max-h-textWImage"
              sizes="100vw lg:50vw"
            />
          </figure>
        </BaseScrollTransition>
      </div>
    </article>
  </BaseComponentWrapper>
</template>
